<ng-container *ngIf="isLoaded; else loading">
  <ng-container *ngIf="!ShouldSkip; else loading">
    <div class="step-container">
      <h5 class="text-primary text-center text-lg-start">Terms & Conditions</h5>

      <div class="terms font-size-14">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType.General" [defaultTerms]="loading"></fgbcl-terms-and-conditions>
      </div>

      <div class="mt-2 mt-lg-3 mb-5 mb-lg-4 pb-5 pb-lg-2">
        <div class="accept-box">
          <input type="checkbox" id="accepted" [(ngModel)]="accepted" required />
          <label for="accepted" class="d-inline-block font-size-12 ps-2 fw-bold">Accept terms and conditions</label>
          <fgbcl-errors></fgbcl-errors>
        </div>
      </div>

      <div class="button-container mt-auto">
        <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
